import app from "../reducers/app";

export const AppSelector = {
  state: (state) => state[app.name],
  headerType: (state) => AppSelector.state(state).headerType,
  headerHeight: (state) => AppSelector.state(state).height,
};
